import React from 'react';
import shared from './GarageContent.module.scss';
import classes from './PurchaseCard.module.scss';
import { DEALER_PURCHASE_STATUSES } from '../../services/dealerGarage';

const STEP_CLASSES = {
    done: classes.stepDone,
    current: classes.stepCurrent,
    upcoming: classes.stepUpcoming,
};

const STEP_SR_TEXT = {
    done: ' (done)',
    current: ' (current step)',
    upcoming: '',
};

/**
 * Where each step of this car's plan stands: 'done', 'current' or 'upcoming'.
 *
 * Staff can put a car on a step outside its plan (a mis-click not yet
 * corrected); then the plan's steps that come earlier in the full `pipeline`
 * count as done and none is marked current.
 */
const stepStates = (plan, status, pipeline) => {
    const at = plan.indexOf(status);
    if (at === -1) {
        const order = pipeline.indexOf(status);
        return plan.map((step) => (pipeline.indexOf(step) < order ? 'done' : 'upcoming'));
    }
    return plan.map((_, i) => {
        if (i < at) return 'done';
        if (i > at) return 'upcoming';
        // Nothing comes after the last step, so reaching it means done.
        return status === 'Completed' ? 'done' : 'current';
    });
};

/**
 * Horizontal step tracker on wide screens, a vertical list on phones.
 * `pipeline` is every status in order, for a status outside `plan`.
 */
const ProgressTracker = ({ plan, status, pipeline = DEALER_PURCHASE_STATUSES }) => {
    const states = stepStates(plan, status, pipeline);
    return (
        <ol className={classes.tracker} aria-label="Purchase progress">
            {plan.map((step, i) => (
                <li
                    key={step}
                    className={STEP_CLASSES[states[i]]}
                    aria-current={states[i] === 'current' ? 'step' : undefined}
                >
                    <span className={classes.trackerDot} aria-hidden="true">
                        {states[i] === 'done' ? <i className="fas fa-check"></i> : i + 1}
                    </span>
                    <span className={classes.trackerLabel}>
                        {step}
                        <span className={shared.srOnly}>{STEP_SR_TEXT[states[i]]}</span>
                    </span>
                </li>
            ))}
        </ol>
    );
};

export default ProgressTracker;
